import { useSearchParams } from 'react-router';

import { PROJECT_MODE } from '@utils/constants';
import useSetSearchParams from '@hooks/useSetSearchParams.hook';

/**
 * The active project-type tab, held in the URL `tab` param so it survives
 * reloads and shared links. Anything other than single image — including a
 * missing or unknown param — resolves to orthophoto.
 *
 * @returns {[string, (tab: string) => void]} the active `PROJECT_MODE` value and a setter
 *   that keeps the page's other search params.
 */
export const useProjectTypeFilter = () => {
	const [searchParams] = useSearchParams();
	const setSearchParams = useSetSearchParams();

	const activeTab =
		searchParams.get('tab') === PROJECT_MODE.SINGLE_IMAGE
			? PROJECT_MODE.SINGLE_IMAGE
			: PROJECT_MODE.ORTHOPHOTO;

	const setActiveTab = tab => setSearchParams({ tab });

	return [activeTab, setActiveTab];
};
